'use client';
import React, { useState, useEffect } from 'react';
import { updateUser } from '../../utils/apiHandler'; // Import updateUser function
import { useAuth0 } from '@auth0/auth0-react';

export default function UserInfo({ userData, tokenId }) {
  const { getIdTokenClaims, isAuthenticated, getAccessTokenWithPopup, logout, user } = useAuth0();
  const [showButton, setShowButton] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile_number: '',
  });

  const [isButtonEnabled, setIsButtonEnabled] = useState(false); // Track if the save button should be enabled

  // Handle change in input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: value,
      };
      // Check if any field is modified compared to the initial userData
      const isModified = Object.keys(updatedData).some((key) => updatedData[key] !== userData[key]);
      setIsButtonEnabled(isModified); // Enable the button if changes are made
      return updatedData;
    });
  };

  // Handle form submission
  const handleSave = async (e) => {
    e.preventDefault();

    console.log('Form data saved:', formData);
    try {
      const body = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        mobile_number: formData.mobile_number,
      };

      // Call updateUser to make the PATCH request
      const isUpdated = await updateUser(
        getIdTokenClaims, // pass the function to get the ID token
        body,
        false, // We don't need to check MLS here
        getAccessTokenWithPopup, // pass the function to get the access token
        logout // pass the logout function
      );

      if (!isUpdated) {
        console.error('Failed to update user data');
      } else {
        console.log('User data updated successfully');
      }
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };

  useEffect(() => {
    // Populate form data with userData
    if (userData) {
      setFormData({
        firstName: userData.first_name || '',
        lastName: userData.last_name || '',
        email: userData.email || '',
        mobile_number: userData.mobile_number || '',
      });
    }
  }, [userData]);

  useEffect(() => {
    const buttonTimeout = setTimeout(() => setShowButton(true), 400); // Delay button appearance

    return () => {
      clearTimeout(buttonTimeout);
    };
  }, []);

  return (
    <div className="p-6">

      {/* Form Section */}
      <form className="space-y-4">
        {/* First Name */}
        <div className="mb-4">
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="Enter your first name"
            className="mt-1 block w-full px-6 py-4 border border-gray-300 rounded-full shadow-sm outline-none text-sm sm:text-lg"
            required
          />
        </div>

        {/* Last Name */}
        <div className="mb-4">
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Enter your last name"
            className="mt-1 block w-full px-6 py-4 border border-gray-300 rounded-full shadow-sm outline-none text-sm sm:text-lg"
            required
          />
        </div>

        {/* Email */}
        <div className="mb-4">
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email address"
            className="mt-1 block w-full px-6 py-4 border border-gray-300 rounded-full shadow-sm outline-none text-sm sm:text-lg"
            required
          />
        </div>

        {/* mobile_number */}
        <div className="mb-4">
          <input
            type="tel"
            id="mobile_number"
            name="mobile_number"
            value={formData.mobile_number}
            onChange={handleChange}
            placeholder="Enter your mobile_number number"
            className="mt-1 block w-full px-6 py-4 border border-gray-300 rounded-full shadow-sm outline-none text-sm sm:text-lg"
            required
          />
        </div>
      </form>

      {/* Save Button */}
      <div className={`absolute w-[90%] sm:bottom-4 mt-6 mx-auto ${showButton ? 'show' : ''}`}>
        <button
          onClick={handleSave}
          className={`w-full py-[15px] px-6 bg-[#0062ff] text-white rounded-full hover:bg-blue-600 text-sm sm:text-lg ${!isButtonEnabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={!isButtonEnabled} // Disable the button if no changes are made
        >
          Save Changes
        </button>
      </div>
    </div>
  );
}
